import React from 'react';

const statusLabel = (status = 'not_applicable') => {
  const normalized = String(status || '').toLowerCase();
  if (normalized === 'compliant') return { label: 'Compliant', className: 'badge--low' };
  if (normalized === 'partially_compliant') return { label: 'Partially Compliant', className: 'badge--medium' };
  if (normalized === 'non_compliant') return { label: 'Non-Compliant', className: 'badge--high' };
  return { label: 'Not Applicable', className: 'badge--low' };
};

const checkStatusLabel = (status = 'partially_met') => {
  const normalized = String(status || '').toLowerCase();
  if (normalized === 'met') return { label: 'Met', className: 'badge--low' };
  if (normalized === 'not_met') return { label: 'Not Met', className: 'badge--high' };
  return { label: 'Partially Met', className: 'badge--medium' };
};

const ComplianceReport = ({ report }) => {
  const overall = statusLabel(report?.overall_status);
  const checks = Array.isArray(report?.checks) ? report.checks : [];
  const frameworks = Array.isArray(report?.guidance_frameworks) ? report.guidance_frameworks : [];
  const recommendations = Array.isArray(report?.recommendations) ? report.recommendations : [];

  return (
    <div className="merge-report">
      <div className="merge-report__header">
        <h3>Compliance Report</h3>
        <div className={`badge ${overall.className}`}>{overall.label}</div>
      </div>

      <section className="report-section">
        <h4>Summary</h4>
        <p className="summary-text">{report?.compliance_summary || 'No compliance summary available.'}</p>
        {report?.instruction_text && (
          <p className="muted"><strong>Instruction:</strong> {report.instruction_text}</p>
        )}
      </section>

      {frameworks.length > 0 && (
        <section className="report-section">
          <h4>Guidance Frameworks</h4>
          <ul className="insight-list">
            {frameworks.map((item, index) => (
              <li key={`${index}-${item}`}>{item}</li>
            ))}
          </ul>
        </section>
      )}

      {checks.length > 0 && (
        <section className="report-section">
          <h4>Requirement Checks</h4>
          <div className="concerns-list">
            {checks.map((check, index) => {
              const checkStatus = checkStatusLabel(check.status);
              return (
                <article key={`${index}-${String(check.requirement || '').slice(0, 24)}`} className="concern-card">
                  <p><strong>{check.requirement || 'Requirement'}</strong></p>
                  <span className={`badge ${checkStatus.className}`}>{checkStatus.label}</span>
                  {check.risk_level && <p className="muted"><strong>Risk:</strong> {check.risk_level}</p>}
                  {check.guidance_reference && <p className="muted"><strong>Guidance:</strong> {check.guidance_reference}</p>}
                  {check.policy_section && <p className="muted"><strong>Policy Section:</strong> {check.policy_section}</p>}
                  {check.evidence && <p className="muted"><strong>Evidence:</strong> {check.evidence}</p>}
                  {check.evidence_quote && <p className="muted"><strong>Evidence Quote:</strong> "{check.evidence_quote}"</p>}
                  {check.recommendation && <p className="muted"><strong>Recommendation:</strong> {check.recommendation}</p>}
                </article>
              );
            })}
          </div>
        </section>
      )}

      {recommendations.length > 0 && (
        <section className="report-section">
          <h4>Recommendations</h4>
          <ul className="insight-list">
            {recommendations.map((item, index) => (
              <li key={`${index}-${String(item).slice(0, 20)}`}>{String(item)}</li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
};

export default ComplianceReport;
